var BHERO1 = (function () {
  function init() {
    const modal = document.querySelector(".c-video-modal");
    const modalClose = document.querySelector(".c-video-modal__close");
    const iframeWrapper = document.querySelector(
      ".c-video-modal__iframe-wrapper"
    );
    const button = document.querySelector(".b-hero-1__video-button");
    const youtubeCode = button.dataset.youtubeVideo;

    const iframe = document.createElement("iframe");
    iframe.src = `https://www.youtube.com/embed/${youtubeCode}?autoplay=1`;
    iframe.setAttribute(
      "allow",
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    );
    iframe.setAttribute("allowfullscreen", true);

    button.addEventListener("click", function (e) {
      e.preventDefault();
      iframeWrapper.appendChild(iframe);
      modal.classList.add("is-open");
    });

    modalClose.addEventListener("click", function (e) {
      e.preventDefault();
      modal.classList.remove("is-open");
      iframe.remove();
    });

    document.addEventListener("click", function (e) {
      if (!iframeWrapper.contains(e.target) && !button.contains(e.target)) {
        modal.classList.remove("is-open");
        iframe.remove();
      }
    });
  }

  return {
    init: init,
  };
})();
